import { Box, Grid, Heading} from "@chakra-ui/react"
import LoginForm from "../components/loginForm"

const LoginPage = () => {
    return(
        <Box w="100%" h="100vh">
            <Grid w="100%" h="100%" placeItems="center">
                <Box w={['300px']} px={4} py={8}>
                    <Heading as="h1" mb={4}>Databridge</Heading>
                    <LoginForm/>
                </Box>
            </Grid>
        </Box>
    )
}

export default LoginPage